import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
} from "reactstrap";
import Papa from "papaparse";
import { importLaborSpreadsheetEmployee } from "helpers/fakebackend_helper";

const ImportLaborSpreadsheetReportModal = ({ isOpen, toggle }) => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [file, setFile] = useState(null);
    const [parsedData, setParsedData] = useState([]);
    const [isCorrectFormat, setIsCorrectFormat] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleFileChange = (e) => {
        const uploadedFile = e.target.files[0];
        setFile(uploadedFile);

        Papa.parse(uploadedFile, {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                const rows = results.data;

                const formatted = rows
                    .filter(row =>
                        row["<< Last day of the month"] !== ""
                        && row["<< Last day of the month"] !== "Name"
                        && row["_10"] !== "-"
                        && row["_10"] !== ""
                    )
                    .map(row => {
                        return {
                            full_name: row["<< Last day of the month"],
                            location_name: row["_12"],
                            hours: [row["Friday"], row["Saturday"], row["Sunday"], row["Monday"], row["Tuesday"], row["Wednesday"], row["Thursday"], row["Friday_1"], row["Saturday_1"], row["Sunday_1"], row["Monday_1"], row["Tuesday_1"], row["Wednesday_1"], row['Thursday_1'], row["Friday_2"], row["Saturday_2"], row["Sunday_2"], row["Monday_2"], row["Tuesday_2"], row["Wednesday_2"], row["Thursday_2"], row["Friday_3"], row["Saturday_3"], row["Sunday_3"], row["Monday_3"], row["Tuesday_3"], row["Wednesday_3"], row["Thursday_3"], row["Friday_4"], row["Saturday_4"], row["Sunday_4"]],
                            manager: row["_1"],
                            rate: row["_3"],
                            net_hours: row["_10"],
                            net_pay: row["_13"],
                            type: row["_19"],
                        };
                    });

                // setParsedData(formatted.slice(0, 1));
                setParsedData(formatted);
                setIsCorrectFormat(1);
            }
        });
    };

    const importData = async () => {
        try {
            setLoading(true);
            await importLaborSpreadsheetEmployee(user.token, parsedData);
        } catch (error) {
            console.error("Import failed:", error);
        } finally {
            toggle()
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Import Labor Spreadsheet Report</ModalHeader>
            <ModalBody>
                <Input type="file" onChange={handleFileChange} accept=".csv" />

                {file && (
                    <div className="mt-3">
                        <h6>File Information</h6>
                        <p className="mb-1">
                            <strong>Name:</strong> {file.name}
                        </p>
                        <p className="mb-1">
                            <strong>Size:</strong>{" "}
                            {(file.size / 1024 / 1024).toFixed(2)} MB
                        </p>
                        <p className="mb-1">
                            <strong>Type:</strong> {file.type || "N/A"}
                        </p>
                        <p className="mb-1">
                            <strong>Correct Format?:</strong>
                            {isCorrectFormat === 1 ? (
                                <span
                                    className="badge bg-success"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 10,
                                        padding: 5,
                                        color: "#FFFFFF",
                                        marginLeft: 10
                                    }}
                                >
                                    YES
                                </span>
                            ) : isCorrectFormat === 0 ? (
                                <span
                                    className="badge bg-danger"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 10,
                                        padding: 5,
                                        color: "#FFFFFF",
                                        marginLeft: 10
                                    }}
                                >
                                    NO, CONTACT DEVELOPER
                                </span>
                            ) : null}
                        </p>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Close
                </Button>
                {isCorrectFormat === 1 && (
                    <Button
                        color="primary"
                        onClick={importData}
                        disabled={loading}
                    >
                        {loading ? "Importing..." : "Import Data"}
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    );
};

export default ImportLaborSpreadsheetReportModal;